import type { StockTransferStatus } from "@/modules/inventory/presentation/api/client";
import { Badge } from "@/components/ui/badge";

export const TRANSFER_STATUS_LABELS: Record<StockTransferStatus, string> = {
  DRAFT: "ຮ່າງ",
  SUBMITTED: "ລໍຖ້າອະນຸມັດ",
  REJECTED: "ປະຕິເສດ",
  APPROVED: "ອະນຸມັດແລ້ວ",
  SHIPPED: "ຈັດສົ່ງແລ້ວ",
  RECEIVED: "ຮັບແລ້ວ",
  CLOSED: "ປິດງານ",
  CANCELLED: "ຍົກເລີກ",
};

const VARIANT: Record<
  StockTransferStatus,
  "default" | "secondary" | "destructive" | "outline"
> = {
  DRAFT: "secondary",
  SUBMITTED: "default",
  REJECTED: "destructive",
  APPROVED: "outline",
  SHIPPED: "default",
  RECEIVED: "outline",
  CLOSED: "secondary",
  CANCELLED: "destructive",
};

export function TransferStatusBadge({ status }: { status: StockTransferStatus }) {
  return <Badge variant={VARIANT[status]}>{TRANSFER_STATUS_LABELS[status]}</Badge>;
}
